import React from 'react';
import { borderColor } from '../../Utilities/utils/Theming';
import { activePathThemes, presetBorderSizes, presetSizes, spinnerContainerStyle, loadingLabelStyle } from './styles';
import { Keyframes } from './KeyFrame';
import { useStyletron } from '../../Themes';

import { IDummyProps } from './types';

export const View = React.forwardRef(({ size = 'small', theme = 'default', customSize, customWidth, customTrackColor, customActiveColor, loadingText, ...rest }: IDummyProps, ref: any) => {

  const spinerStyle = {
    borderWidth: customWidth || presetBorderSizes[size],
    width: customSize || presetSizes[size],
    height: customSize || presetSizes[size],
    display: 'inline-block',
    borderStyle: 'solid',
    ...borderColor(customTrackColor || activePathThemes[theme]),
    borderRadius: '50%',
    borderLeftColor: customActiveColor || 'transparent',
    animationTimingFunction: 'linear',
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationName: 'epo-spinner'
  }

  const [css]: any = useStyletron();

  return (
    <div className={css({ ...spinnerContainerStyle })}>
      <Keyframes name="epo-spinner" from={{ transform: 'rotate(0deg)' }} to={{ transform: 'rotate(360deg)' }} />
      <span style={spinerStyle} {...rest} ref={ref} {...{ theme: theme }} role="alert">
      </span>
      {(size !== 'small' && loadingText) && <div style={loadingLabelStyle}>Loading...</div>}
    </div>
  );
});

